import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { AddCreditCard as RedesignAddCreditCard } from '../../../pages';
import { paymentActions } from '../../redux';
import { flagService } from '../../services';
import { default as LegacyCreditCard } from './index.weborder';

const pageComponent = flagService.componentToggle(
  'uiRedesign',
  RedesignAddCreditCard,
  LegacyCreditCard,
);

export type StateProps = {
  translate: any;
};
export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: WebOrder.State) => ({
  translate: getTranslate(state.locale),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<WebOrder.State, {}, Action>,
) => ({
  cancelAddCardBridge: () => {
    dispatch(paymentActions.cancelAddBridge());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(pageComponent);
